import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./LandingPage/Pages/auth/login";
import News from "./LandingPage/Pages/dashboard/news/news";
import NewsDetail from "./LandingPage/Pages/dashboard/news/detail-berita";
import RouteGuard from "./utils/RouteGuard";
import DashboardLayout from "./LandingPage/Pages/dashboard/page-dashboard";
import TambahNews from "./LandingPage/Pages/dashboard/news/tambah-news";
import TambahKategori from "./LandingPage/Pages/dashboard/news/tambahkategori";
import VisitorStats from "./LandingPage/Pages/dashboard/visitor/visitor";
import VideoTable from "./LandingPage/Pages/dashboard/videoUpload/video";
import TambahVideo from "./LandingPage/Pages/dashboard/videoUpload/tambah-video";
import VideoDetail from "./LandingPage/Pages/dashboard/videoUpload/detail-video";
import Editorial from "./LandingPage/Pages/dashboard/Editorial/editorial";
import EditorialDetail from "./LandingPage/Pages/dashboard/Editorial/detail-EDITORIAL";
import TambahEditorial from "./LandingPage/Pages/dashboard/Editorial/tambah-editorial";
import EditorialPublic from "./LandingPage/Pages/dashboard/EditorialPublic/editorialPublic";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />

        {/* ✅ Protected dashboard with layout and nested routes */}
        <Route
          path="/dashboard"
          element={
            <RouteGuard>
              <DashboardLayout />
            </RouteGuard>
          }>
          <Route path="news" element={<News />} />
          <Route path="news-detail/:id" element={<NewsDetail />} />
          <Route path="news/tambah" element={<TambahNews />} />
          <Route path="news/tambah-kategori" element={<TambahKategori />} />

          <Route path="editorial" element={<Editorial />} />
          <Route path="editorial/detail/:id" element={<EditorialDetail />} />
          <Route path="editorial/tambah" element={<TambahEditorial />} />
          <Route path="editorialPublic" element={<EditorialPublic />} />

          <Route path="visitor" element={<VisitorStats />} />
          <Route path="video" element={<VideoTable />} />
          <Route path="video/tambah" element={<TambahVideo />} />
          <Route path="video/detail/:id" element={<VideoDetail />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
